import { Container, Row, Col, Image, Button } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "../../homepage/homepage.css";
import user from "../../../assets/user.png";
import user2 from "../../../assets/user2.png";
import shipper from "../../../assets/shipper.png";
import shipper2 from "../../../assets/shipper2.png";
import rider from "../../../assets/rider.png";
import rider2 from "../../../assets/rider2.png";
import transporter from "../../../assets/transporter.png";
import transporter2 from "../../../assets/transporter2.png";

import AppStoreSvg from "../component/ButtonComponents/appstore";
import PlayStoreSvg from "../component/ButtonComponents/playstore";

import AnimatedWrapper from "./AnimatedWrapper"

import { Links } from "../../Links";

function Products() {
  const bullet = {
    backgroundColor: '#F36F2E',
    height: 1.6 + 'rem',
    width: 1.6 + 'rem',
    borderRadius: 50 + 'px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    minWidth: '1.6rem', flexShrink: 0,

  }

  return (
    <Container fluid className="productsection">

      <Tabs
        defaultActiveKey="rider"
        id="justify-tab-example"
        className="mb-3 producttab"
        justify
      >
        <Tab eventKey="rider" title="Rider">
          <Container fluid>
            <AnimatedWrapper delay={0.1}>
              <div style={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                <h2 className="productheader"><strong><span style={{ color: '#F36F2E' }}>Your Ride, </span>Your Way</strong></h2>
                <p className="producttext">
                  Enjoy convenient transportation with just a few taps on the Lodapoint app.
                  Enjoy convenient transportation with just a few taps on
                  Lodapoint app.
                </p>
              </div>
            </AnimatedWrapper>
            <br />

            <Row className="productsectionrow">
              <Col xs={12} sm={12} md={5} lg={5} >
                <AnimatedWrapper delay={0.2}>
                  <Image className="shipperimage" src={rider} fluid />
                </AnimatedWrapper>
                <br /><br />

                <AnimatedWrapper delay={0.4}>
                  <Image className="shipperimage" src={rider2} fluid />
                </AnimatedWrapper>
              </Col>
              <Col xs={12} sm={12} md={7} lg={7} >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>

                  <AnimatedWrapper delay={0.2}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        1
                      </div>
                      <div>
                        <h6><strong> Download the App</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>Download THE LODAPOINT mobile application from the respective app store and Sign up
                        </p>
                        <div className="downloadbtn">
                          <Button
                            variant="primary"

                           href={Links.User.playStore}
                            target="_blank"
                            rel="noopener noreferrer"

                            style={{
                              backgroundColor: "#F36F2E",
                              borderColor: "#313434",
                              borderRadius: 36 + "px",
                              paddingTop: 7 + 'px'


                            }}
                            className="buttondownload"
                            size="sm"
                          >
                            <PlayStoreSvg />
                          </Button>
                          <Button
                            variant="primary"

                             href={Links.User.appStore}
                            target="_blank"
                            rel="noopener noreferrer"

                            style={{
                              backgroundColor: "#F36F2E",
                              borderColor: "#313434",
                              color: "#FFFFF",
                              borderRadius: 36 + "px",
                              paddingTop: 7 + 'px'

                            }}
                            className="buttondownload"
                            size="sm"
                          >
                            <AppStoreSvg />
                          </Button>
                        </div>
                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.4}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        2
                      </div>


                      <div>
                        <h6><strong>Choose your service of choice;
                        </strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Select between car ride, tricycle and truck hailing options based on your needs.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.6}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        3
                      </div>
                      <div>
                        <h6><strong>Book Your Trip/Delivery:
                        </strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Enter your pickup location, destination and Payment method to get matched with a driver.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>


                  <AnimatedWrapper delay={0.8}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        4
                      </div>
                      <div>
                        <h6><strong>Track Your Driver:</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Monitor your ride in real-time to know exactly when to expect your driver.

                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={1.0}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        5
                      </div>
                      <div>
                        <h6><strong>Safety Check:
                        </strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Confirm that vehicle details and driver match with that of your app upon arrival of your ride or truck before engagement.

                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={1.2}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        6
                      </div>
                      <div>
                        <h6><strong>Rate Your Experience:</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          At the end of your ride/delivery, pls provide feedback to help improve our services.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                </div>
              </Col>
            </Row>
          </Container>

        </Tab>

        <Tab eventKey="shipper" title="Sender">
          <Container fluid>
            <AnimatedWrapper delay={0.1}>
              <div style={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                <h2 className="productheader"><strong><span style={{ color: '#F36F2E' }}>Seamless</span> Shipping Solutions</strong></h2>
                <p className="producttext">
                  Effortlessly manage your cargo from pickup to delivery with Lodapoint.
                </p>
              </div>
            </AnimatedWrapper>


            <Row className="productsectionrow">
              <Col xs={12} sm={12} md={5} lg={5} >
                <AnimatedWrapper delay={0.2}>
                  <Image className="shipperimage" src={user} fluid />
                </AnimatedWrapper>
                <br /><br />

                <AnimatedWrapper delay={0.4}>
                  <Image className="shipperimage" src={user2} fluid />
                </AnimatedWrapper>
              </Col>
              <Col xs={12} sm={12} md={7} lg={7} >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>

                  <AnimatedWrapper delay={0.2}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        1
                      </div>
                      <div>
                        <h6><strong>Download “Lodapoint” app</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>Begin by downloading THE LODAPOINT mobile application from the respective app store.
                        </p>
                        <div className="downloadbtn">
                          <Button
                            variant="primary"

                            href={Links.User.playStore}
                            target="_blank"
                            rel="noopener noreferrer"

                            style={{
                              backgroundColor: "#F36F2E",
                              borderColor: "#313434",
                              borderRadius: 36 + "px",
                              paddingTop: 7 + 'px'

                            }}
                            className="buttondownload"
                            size="sm"
                          >
                         <PlayStoreSvg />
                          </Button>
                          <Button
                            variant="primary"

                            href={Links.User.appStore}
                            target="_blank"
                            rel="noopener noreferrer"

                            style={{
                              backgroundColor: "#F36F2E",
                              borderColor: "#313434",
                              color: "#FFFFF",
                              borderRadius: 36 + "px",
                              paddingTop: 7 + 'px'

                            }}
                            className="buttondownload"
                            size="sm"
                          >
                           <AppStoreSvg />

                          </Button>
                        </div>
                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.4}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        2
                      </div>


                      <div>
                        <h6><strong>Register Your Account</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Create an account on the Lodapoint app to start managing your shipments.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.6}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        3
                      </div>
                      <div>
                        <h6><strong>Creat a shipping request:</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Fill in details about your cargo including pickup/drop-off locations, size,
                          weight, and truck type needed as well as your payment method and then  you will be matched with a Truck
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.8}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        4
                      </div>
                      <div>
                        <h6><strong>Safety Confirmation:</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Upon arrival of the truck, pls check to confirm that all truck and driver details displayed
                          on your app match that of the truck that arrived before loading.
                          Also check your app to confirm loading when the truck is successfully loaded.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.9}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        5
                      </div>
                      <div>
                        <h6><strong>Track Your Shipment: </strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Use real-time tracking to monitor your cargo throughout the entire delivery process.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={1.0}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        6
                      </div>
                      <div>
                        <h6><strong>Rate your experience:</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          At the completion your delivery, please provide feedback to help improve our services
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>





                </div>
              </Col>
            </Row>
          </Container>

        </Tab>



        <Tab eventKey="driver" title="Driver">
          <Container fluid>
            <AnimatedWrapper delay={0.1}>
              <div style={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                <h2 className="productheader"><strong>Drive Your Success</strong></h2>
                <p className="producttext">
                  Unlock new earning potential and flexibility with Lodapoint.
                </p>
              </div>
            </AnimatedWrapper>
            <br />

            <Row className="productsectionrow">
              <Col xs={12} sm={12} md={5} lg={5} >
                <AnimatedWrapper delay={0.2}>
                  <Image className="shipperimage" src={shipper} fluid />
                </AnimatedWrapper>
                <br /><br />

                <AnimatedWrapper delay={0.4}>
                  <Image className="shipperimage" src={shipper2} fluid />
                </AnimatedWrapper>
              </Col>
              <Col xs={12} sm={12} md={7} lg={7} >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>

                  <AnimatedWrapper delay={0.2}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        1
                      </div>
                      <div>
                        <h6><strong>Download “Lodapoint Driver” App.
                        </strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Install Lodapoint Driver app on your mobile device and Register as a driver by
                          filling in and uploading your personal and vehicle details, then submit your application.
                        </p>
                        <div className="downloadbtn">
                          <Button
                            variant="primary"

                            href={Links.Driver.playStore}
                            target="_blank"
                            rel="noopener noreferrer"

                            style={{
                              backgroundColor: "#F36F2E",
                              borderColor: "#313434",
                              borderRadius: 36 + "px",
                              paddingTop: 7 + 'px'

                            }}
                            className="buttondownload"
                            size="sm"
                          >
                           <PlayStoreSvg />
                          </Button>
                          <Button
                            variant="primary"

                            href={Links.Driver.appStore}
                            target="_blank"
                            rel="noopener noreferrer"

                            style={{
                              backgroundColor: "#F36F2E",
                              borderColor: "#313434",
                              color: "#FFFFF",
                              borderRadius: 36 + "px",
                              paddingTop: 7 + 'px'

                            }}
                            className="buttondownload"
                            size="sm"
                          >
                           <AppStoreSvg />
                          </Button>
                        </div>
                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.4}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        2
                      </div>


                      <div>
                        <h6><strong>Driver/Vehicle inspection and Confirmation.
                        </strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          A notification, mail or text message will be sent to you with details of
                          where and when you can come in with your vehicle for inspection and confirmation.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.6}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        3
                      </div>
                      <div>
                        <h6><strong> Account Activation</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Once your application is reviewed and your vehicle passes inspection,
                          you’ll be onboarded and ready to start earning.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.8}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        4
                      </div>
                      <div>
                        <h6><strong>Go Online and start earning
                        </strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          You can now go online to be able to receive notifications for ride or
                          delivery job requests that match your vehicle.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.9}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        5
                      </div>
                      <div>
                        <h6><strong>Accept Job Requests
                        </strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Accept the requests of your choice, confirm payment method and immediately head for pickup.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={1.2}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div style={bullet}>
                        5
                      </div>
                      <div>
                        <h6><strong>Navigate Efficiently

                        </strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Use real-time navigation to optimize routes, ensure smooth/safe rides and timely arrivals
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                </div>
              </Col>
            </Row>
          </Container>

        </Tab>

        <Tab eventKey="transporter" title="Transporter">
          <Container fluid>
            <AnimatedWrapper delay={0.1}>
              <div style={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                <h2 className="productheader"><strong>Optimize Your Fleet</strong></h2>
                <p className="producttext">
                  Maximize revenue and efficiency with Lodapoint’s robust platform.
                </p>
              </div>
            </AnimatedWrapper>
            <br />

            <Row className="productsectionrow">
              <Col xs={12} sm={12} md={5} lg={5} >
                <AnimatedWrapper delay={0.2}>
                  <Image className="shipperimage" src={transporter} fluid />
                </AnimatedWrapper>
                <br /><br />
                <AnimatedWrapper delay={0.4}>
                  <Image className="shipperimage" src={transporter2} fluid />
                </AnimatedWrapper>
              </Col>
              <Col xs={12} sm={12} md={7} lg={7} >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>

                  <AnimatedWrapper delay={0.2}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div>
                        <svg width="28" height="28" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.533447" y="0.755127" width="40" height="40" rx="20" fill="#F36F2E" />
                          <path d="M18.1264 17.1329V14.6102H22.8393V28.8662H20.0233V17.1329H18.1264Z" fill="white" />
                        </svg>
                      </div>
                      <div>
                        <h6><strong>Register Your Fleet</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Create an account and and register your vehicles and drivers to Lodapoint platform.
                        </p>
                        <div className="downloadbtn">
                          <Button
                            variant="primary"

                            href={Links.Transporter.playStore}
                            target="_blank"
                            rel="noopener noreferrer"

                            style={{
                              backgroundColor: "#F36F2E",
                              borderColor: "#313434",
                              borderRadius: 36 + "px",
                              paddingTop: 7 + 'px'

                            }}
                            className="buttondownload"
                            size="sm"
                          >
                            <PlayStoreSvg />
                          </Button>
                          <Button
                            variant="primary"

                            href={Links.Transporter.appStore}
                            target="_blank"
                            rel="noopener noreferrer"

                            style={{
                              backgroundColor: "#F36F2E",
                              borderColor: "#313434",
                              color: "#FFFFF",
                              borderRadius: 36 + "px",

                            }}
                            className="buttondownload"
                            size="sm"
                          >
                           <AppStoreSvg />
                          </Button>
                        </div>
                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.4}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div>
                        <svg width="28" height="28" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.533447" y="0.755127" width="40" height="40" rx="20" fill="#F36F2E" />
                          <path d="M16.4301 25.7764C17.6816 24.7335 18.679 23.8665 19.4221 23.1755C20.1652 22.4715 20.7845 21.7415 21.2799 20.9853C21.7753 20.2292 22.023 19.4861 22.023 18.756C22.023 18.0911 21.8665 17.5696 21.5536 17.1915C21.2408 16.8135 20.7584 16.6244 20.1065 16.6244C19.4547 16.6244 18.9528 16.8461 18.6008 17.2893C18.2488 17.7195 18.0662 18.3127 18.0532 19.0689H15.3936C15.4458 17.5044 15.9086 16.3181 16.7821 15.5098C17.6686 14.7015 18.7898 14.2973 20.1456 14.2973C21.6319 14.2973 22.7726 14.695 23.5679 15.4902C24.3631 16.2724 24.7608 17.3089 24.7608 18.5995C24.7608 19.6164 24.487 20.5877 23.9394 21.5133C23.3919 22.439 22.7661 23.2472 22.0621 23.9382C21.3581 24.6161 20.439 25.4375 19.3048 26.4022H25.0736V28.6707H15.4132V26.6369L16.4301 25.7764Z" fill="white" />
                        </svg>
                      </div>
                      <div>
                        <h6><strong>Browse Shipping Requests:</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Access a variety of job opportunities that fit your fleet's capabilities.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.6}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div>
                        <svg width="28" height="28" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.533447" y="0.755127" width="40" height="40" rx="20" fill="#F36F2E" />
                          <path d="M15.6088 18.3649C15.6739 17.0612 16.1302 16.0573 16.9776 15.3533C17.8381 14.6363 18.9658 14.2778 20.3608 14.2778C21.3125 14.2778 22.1273 14.4472 22.8052 14.7862C23.4831 15.1121 23.9916 15.5619 24.3305 16.1355C24.6825 16.6961 24.8585 17.335 24.8585 18.052C24.8585 18.8733 24.6434 19.5708 24.2132 20.1444C23.796 20.705 23.2941 21.0831 22.7074 21.2787V21.3569C23.4636 21.5915 24.0502 22.0087 24.4674 22.6084C24.8976 23.2081 25.1128 23.9773 25.1128 24.916C25.1128 25.6982 24.9302 26.3957 24.5652 27.0084C24.2132 27.6212 23.6852 28.1035 22.9812 28.4555C22.2902 28.7945 21.4559 28.964 20.4781 28.964C19.0049 28.964 17.8055 28.5924 16.8799 27.8493C15.9542 27.1062 15.4654 26.0111 15.4132 24.564H18.0728C18.0988 25.2028 18.3139 25.7178 18.7181 26.1089C19.1353 26.487 19.7024 26.676 20.4194 26.676C21.0843 26.676 21.5928 26.4935 21.9448 26.1284C22.3098 25.7504 22.4923 25.268 22.4923 24.6813C22.4923 23.8991 22.2446 23.3385 21.7492 22.9995C21.2538 22.6606 20.4846 22.4911 19.4416 22.4911H18.8745V20.2422H19.4416C21.2929 20.2422 22.2185 19.623 22.2185 18.3844C22.2185 17.8238 22.0491 17.3871 21.7101 17.0742C21.3842 16.7613 20.9083 16.6049 20.2825 16.6049C19.6698 16.6049 19.1939 16.7744 18.855 17.1133C18.5291 17.4392 18.34 17.8564 18.2879 18.3649H15.6088Z" fill="white" />
                        </svg>
                      </div>
                      <div>
                        <h6><strong>Accept Jobs:</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Select and confirm jobs that align with your schedule and available resources.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.8}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div>
                        <svg width="28" height="28" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.533203" y="0.754883" width="40" height="40" rx="20" fill="#F36F2E" />
                          <path d="M14.9191 24.2231V22.072L21.3138 12.92H24.5013V21.8373H26.2222V24.2231H24.5013V27H21.7636V24.2231H14.9191ZM21.9396 15.8533L17.9307 21.8373H21.9396V15.8533Z" fill="white" />
                        </svg>
                      </div>
                      <div>
                        <h6><strong>Monitor Your Deliveries:</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Use our tracking system to stay updated on shipment statuses and optimize routes.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>

                  <AnimatedWrapper delay={0.9}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
                      <div>
                        <svg width="28" height="28" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.533203" y="0.754883" width="40" height="40" rx="20" fill="#F36F2E" />
                          <path d="M24.6187 15.1102H18.2827V18.4542C18.5564 18.1153 18.9476 17.8415 19.456 17.6329C19.9644 17.4113 20.5055 17.3004 21.0791 17.3004C22.1221 17.3004 22.976 17.5286 23.6409 17.9849C24.3058 18.4412 24.7881 19.0279 25.088 19.7449C25.3879 20.4489 25.5378 21.205 25.5378 22.0133C25.5378 23.5126 25.1076 24.7185 24.2471 25.6311C23.3997 26.5437 22.1873 27 20.6098 27C19.1236 27 17.9372 26.6284 17.0507 25.8853C16.1641 25.1422 15.6622 24.171 15.5449 22.9716H18.2044C18.3218 23.493 18.5825 23.9102 18.9867 24.2231C19.4039 24.536 19.9319 24.6924 20.5707 24.6924C21.3399 24.6924 21.92 24.4513 22.3111 23.9689C22.7022 23.4865 22.8978 22.8477 22.8978 22.0524C22.8978 21.2441 22.6957 20.6314 22.2916 20.2142C21.9004 19.784 21.3203 19.5689 20.5511 19.5689C20.0036 19.5689 19.5473 19.7058 19.1822 19.9796C18.8172 20.2533 18.5564 20.6184 18.4 21.0747H15.7796V12.7049H24.6187V15.1102Z" fill="white" />
                        </svg>
                      </div>
                      <div>
                        <h6><strong>Review Performance:</strong></h6>
                        <p style={{ fontSize: 0.8 + 'rem', fontFamily: 'jost' }}>
                          Analyze trip logs and income summaries to evaluate and enhance your fleet’s performance.
                        </p>

                      </div>

                    </div>
                  </AnimatedWrapper>


                </div>
              </Col>
            </Row>
          </Container>
        </Tab>

      </Tabs>

    </Container>
  );
}

export default Products;
